export const certifications = [
  {
    id: 1,
    name: 'AWS Solutions Architect – Professional',
    issuer: 'Amazon Web Services',
    year: '2024',
  },
  {
    id: 2,
    name: 'AWS Solutions Architect – Associate',
    issuer: 'Amazon Web Services',
    year: '2023',
  },
  {
    id: 3,
    name: 'AWS Cloud Practitioner',
    issuer: 'Amazon Web Services',
    year: '2023',
  },
  {
    id: 4,
    name: 'CCNP: Advanced Routing',
    issuer: 'Cisco',
    year: '2023',
  },
  {
    id: 5,
    name: 'CCNP: Core Networking',
    issuer: 'Cisco',
    year: '2023',
  },
  {
    id: 6,
    name: 'Fortinet NSE4',
    issuer: 'Fortinet',
    year: '2023',
  },
  {
    id: 7,
    name: 'Oracle Java Foundations',
    issuer: 'Oracle',
    year: '2023',
  },
  {
    id: 8,
    name: 'Cisco Network Defense',
    issuer: 'Cisco',
    year: '2022',
  },
  {
    id: 9,
    name: 'IBM Python for AI',
    issuer: 'IBM',
    year: '2022',
  },
  {
    id: 10,
    name: 'CCNAv7: Introduction to Networks',
    issuer: 'Cisco',
    year: '2022',
  },
  {
    id: 11,
    name: 'Advanced Kotlin, Java & Spring Boot',
    issuer: 'Kotlin Academy',
    year: '2025',
  },
  {
    id: 12,
    name: 'Advanced Android Development',
    issuer: 'Google / Android Developer Program',
    year: '2025',
  },
];
